import { createSelector } from 'reselect';

export const selectLocationsSlice = state => state.locations;

export const selectLocations = createSelector(
  selectLocationsSlice,
  slice => slice.locations
);
export const locationsLoaded = createSelector(
  selectLocationsSlice,
  slice => slice.locationsLoaded
);
export const selectActiveLocation = createSelector(
  selectLocationsSlice,
  slice => slice.activeLocation
);

export const locationsMeta = createSelector(
  selectLocationsSlice,
  slice => slice.meta
);
export const locationsFilters = createSelector(
  selectLocationsSlice,
  slice => slice.filters
);

export const locationCreating = createSelector(
  selectLocationsSlice,
  slice => slice.isCreating
);
export const locationUpdating = createSelector(
  selectLocationsSlice,
  slice => slice.isUpdating
);
export const locationDeleting = createSelector(
  selectLocationsSlice,
  slice => slice.isDeleting
);
export const locationsErrors = createSelector(
  selectLocationsSlice,
  slice => slice.errors
);
